import { useI18n } from "@/composables/useI18n";
import { computed } from "vue";

const TIME_UNITS = [
  { unit: "years", seconds: 365 * 24 * 60 * 60 },
  { unit: "months", seconds: 30 * 24 * 60 * 60 },
  { unit: "weeks", seconds: 7 * 24 * 60 * 60 },
  { unit: "days", seconds: 24 * 60 * 60 },
  { unit: "hours", seconds: 60 * 60 },
  { unit: "minutes", seconds: 60 },
  { unit: "seconds", seconds: 1 },
] as const;

export const useRelativeTime = () => {
  const { locale } = useI18n();

  const relativeTimeFormatter = computed(
    () => new Intl.RelativeTimeFormat(locale.value, { numeric: "auto" }),
  );

  const getRelativeTime = (date: Date): string => {
    const diffInSeconds = Math.floor((Date.now() - date.getTime()) / 1000);
    const { unit, seconds } =
      TIME_UNITS.find(({ seconds }) => diffInSeconds >= seconds) ?? TIME_UNITS[6];
    return relativeTimeFormatter.value.format(-Math.floor(diffInSeconds / seconds), unit);
  };

  return {
    getRelativeTime,
  };
};
